export default __webpack_public_path__ + "static/media/sip_logo.27bfdc30.png";